var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.cur_item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              is_disabled: false,
              f_title: _vm.__t("NAME"),
              f_val: _vm.cur_item.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_type: "uniq_id",
              is_disabled: false,
              f_title: _vm.__t("UNIQ_PROV_CODE"),
              f_val: _vm.cur_item.uniq_id,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid_min",
              f_type: "min_qual",
              is_disabled: false,
              f_title: _vm.__t("MIN_QUAL"),
              f_val: _vm.cur_item.min_qual,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid_max",
              f_type: "max_qual",
              is_disabled: false,
              f_title: _vm.__t("MAX_QUAL"),
              f_val: _vm.cur_item.max_qual,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid_ordering",
              f_type: "ordering",
              is_disabled: false,
              f_title: _vm.__t("ORDERING"),
              f_val: _vm.cur_item.ordering,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid3",
              f_title: _vm.__t("UNIQ_ID_CODE"),
              f_val: _vm.cur_item.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "frame-heading" }, [
            _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "custom-control custom-checkbox custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_item.published,
                    expression: "cur_item.published",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "publish" },
                domProps: {
                  checked: Array.isArray(_vm.cur_item.published)
                    ? _vm._i(_vm.cur_item.published, null) > -1
                    : _vm.cur_item.published,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.cur_item.published,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.cur_item,
                              "published",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.cur_item,
                              "published",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.cur_item, "published", $$c)
                      }
                    },
                    function ($event) {
                      return _vm.change_atr("published", _vm.cur_item.published)
                    },
                  ],
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "publish" },
                },
                [_vm._v(_vm._s(_vm.__t("PUBLISHED")))]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }